<template>
    <div ref="dom"></div>
</template>

<script>
import echarts from 'echarts'
import { on, off } from '@/libs/tools'
import { orderStatis } from '@/api/home'
export default {
  name: 'serviceRequests',
  data () {
    return {
      dom: null,
      option: []
    }
  },
  methods: {
    resize () {
      this.dom.resize()
    },
    orderStatis () {
      this.loading = true
      orderStatis().then(res => {
        let data = res.data
        this.option['xAxis'][0]['data'] = data.arr_date
        this.option['series'][0]['data'] = data.arr_num

        this.dom.setOption(this.option)
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    }
  },
  mounted () {
    this.orderStatis()
    const option = {
      title: {
        text: '订单月趋势（单）',
        x: 'center',
        padding: 10,
        textStyle: {
          'color': '#516b91'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      grid: {
        // top: '5%',
        left: '1.2%',
        right: '3%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: []
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          data: [],
          type: 'line',
          itemStyle: {
            normal: {
              color: '#478bee',
              lineStyle: {
                color: '#47c16a'
              }
            }
          }
        }
      ]
    }
    this.option = option
    this.$nextTick(() => {
      this.dom = echarts.init(this.$refs.dom)
      this.dom.setOption(option)
      on(window, 'resize', this.resize)
    })
  },
  beforeDestroy () {
    off(window, 'resize', this.resize)
  }
}
</script>
